import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { GripVertical, Home, MoreVertical } from 'lucide-react';

export function CityRow({
  city, slots, hoveredHour, onHoverHour, nowHour,
  onSetHome, onUnsetHome, onRemove, onStartReorder,
  reorderActive, onDragStart, onDragOver, onDragEnd,
  onSlotClick,
}) {
  const { t } = useTranslation();
  const [menu, setMenu] = useState(null); // { x, y } when open
  const close = () => setMenu(null);

  useEffect(() => {
    if (!menu) return;
    const onDocClick = () => close();
    document.addEventListener('click', onDocClick);
    return () => document.removeEventListener('click', onDocClick);
  }, [menu]);

  const openMenuAtEvent = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setMenu({ x: e.clientX, y: e.clientY });
  };
  const openMenuAtButton = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const r = e.currentTarget.getBoundingClientRect();
    setMenu({ x: r.right + 4, y: r.top });
  };

  return (
    <div
      className={`wv-row wv-city-row${city.isHome ? ' wv-row--home' : ''}${reorderActive ? ' wv-row--reorder' : ''}`}
      draggable={!!reorderActive}
      onDragStart={onDragStart}
      onDragOver={onDragOver}
      onDragEnd={onDragEnd}
      onContextMenu={openMenuAtEvent}
    >
      <div className="wv-row-label">
        {reorderActive && (
          <span className="wv-row-grab" aria-label={t('cityRow.dragHandleLabel')}><GripVertical size={13} /></span>
        )}
        <div className="wv-row-label-title">
          {city.displayName || city.name}
          <span className="wv-tz-badge">{city.tzAbbr}</span>
          <span className={`wv-offset-badge${city.isHome ? ' wv-offset-badge--home' : ''}`}>{city.offsetLabel}</span>
          {city.isHome && <Home size={11} className="wv-row-home-icon" aria-label={t('cityRow.homeIconLabel')} />}
        </div>
        {!reorderActive && (
          <button
            type="button"
            className="wv-row-kebab"
            onClick={openMenuAtButton}
            aria-label={t('cityRow.optionsLabel')}
            title={t('cityRow.optionsTitle')}
          >
            <MoreVertical size={13} />
          </button>
        )}
      </div>
      {menu && (
        <div className="wv-row-context-menu" style={{ position: 'fixed', top: menu.y, left: menu.x }}>
          {city.isHome ? (
            <button onClick={() => { onUnsetHome && onUnsetHome(); close(); }}>
              {t('cityRow.unsetAsHome')}
            </button>
          ) : (
            <button onClick={() => { onSetHome && onSetHome(city.name); close(); }}>
              {t('cityRow.setAsHome')}
            </button>
          )}
          {onStartReorder && (
            <button onClick={() => { onStartReorder(); close(); }}>{t('cityRow.reorderTimezones')}</button>
          )}
          {onRemove && !city.isHome && (
            <button className="wv-row-context-menu--danger" onClick={() => { onRemove(city.name); close(); }}>
              {t('cityRow.removeTimezone')}
            </button>
          )}
        </div>
      )}
      <div className="wv-timeline">
        {slots.map((slot, i) => (
          <div
            key={i}
            data-is-midnight={slot.isMidnight ? 'true' : 'false'}
            className={`wv-slot ${slot.timeOfDay}${hoveredHour === slot.hour ? ' wv-slot--highlight' : ''}${nowHour === slot.hour ? ' wv-slot--now' : ''}`}
            onMouseEnter={onHoverHour ? () => onHoverHour(slot.hour) : undefined}
            onMouseLeave={onHoverHour ? () => onHoverHour(null) : undefined}
            onClick={onSlotClick ? (e) => onSlotClick(e, slot) : undefined}
            style={onSlotClick ? { cursor: 'pointer' } : undefined}
          >
            <div className="wv-slot-hour">{slot.label.split('\n')[0]}</div>
            <div className="wv-slot-period">{slot.label.split('\n')[1] || ''}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
